import { produce } from 'immer'
import {
  GET_USER_INVITE_SUCCESS_ACTION,
  GetUserInviteActions,
} from 'src/app/PeopleDetailFlyout/redux/peopleDetailFlyout.actions'
import {
  GET_INVITED_PEOPLE_FAILURE,
  GET_INVITED_PEOPLE_INIT,
  GET_INVITED_PEOPLE_SUCCESS,
  GetPeopleInvitedToOrgActions,
  REMOVE_ORGANIZATION_INVITE,
  RemoveOrganizationInviteActions,
} from 'src/app/PeopleInvitedToOrg/redux/peopleInvitedToOrg.actions'
import { OrganizationInviteResponse } from 'src/models/organizations.models'
import {
  INVITE_ORGANIZATION_SUCCESS,
  InviteOrganizationActions,
} from 'src/redux/actions/data/organizations.actions'
import { ErrorDetailMap, parseBackendErrors } from 'src/utils/error.utils'

export interface PeopleInvitedToOrgState {
  ids: string[]
  loading: boolean
  complete: boolean
  totalItems?: number
  invitedPeopleTopLevelError?: string
  invitedPeopleErrorDetailMap?: ErrorDetailMap<string>
  page?: number
  numberOfPages?: number
}

export const initialState: PeopleInvitedToOrgState = {
  ids: [],
  loading: false,
  complete: false,
}

export type Actions =
  | GetPeopleInvitedToOrgActions
  | GetUserInviteActions
  | RemoveOrganizationInviteActions
  | InviteOrganizationActions

const CorePeopleInvitedToOrgReducer = (
  state = initialState,
  action: Actions,
): PeopleInvitedToOrgState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_INVITED_PEOPLE_INIT: {
        draft.loading = true
        return draft
      }

      case GET_USER_INVITE_SUCCESS_ACTION: {
        draft.ids = Array.from(
          new Set([
            ...draft.ids,
            ...action.payload.organizationInvites.map(
              (invite: OrganizationInviteResponse) => invite.id,
            ),
          ]),
        )
        draft.loading = false
        return draft
      }

      case GET_INVITED_PEOPLE_SUCCESS: {
        draft.ids =
          action.payload.pagination.page === 0
            ? action.payload.organizationInvites.map(
                (invite: OrganizationInviteResponse) => invite.id,
              )
            : [
                ...draft.ids,
                ...action.payload.organizationInvites.map(
                  (invite: OrganizationInviteResponse) => invite.id,
                ),
              ]
        draft.loading = false
        draft.complete =
          action.payload.pagination.page >=
          action.payload.pagination.numberOfPages - 1
        draft.page = action.payload.pagination.page
        draft.numberOfPages = action.payload.pagination.numberOfPages
        draft.totalItems = action.payload.pagination.totalItems
        return draft
      }

      case INVITE_ORGANIZATION_SUCCESS: {
        draft.ids = [
          ...draft.ids,
          ...action.payload.organizationInvites.map(
            (invite: OrganizationInviteResponse) => invite.id,
          ),
        ]
        return draft
      }

      case GET_INVITED_PEOPLE_FAILURE: {
        const errors = parseBackendErrors(action.payload)

        draft.loading = false
        draft.complete = true
        draft.invitedPeopleTopLevelError = errors.topLevelError
        draft.invitedPeopleErrorDetailMap = errors.errorDetailMap
        return draft
      }

      case REMOVE_ORGANIZATION_INVITE: {
        draft.ids = draft.ids.filter((id) => id !== action.payload)
        return draft
      }
    }
  })
}

const PeopleInvitedToOrgReducer = CorePeopleInvitedToOrgReducer

export default PeopleInvitedToOrgReducer
